import React, {Component} from 'react'
import {Root, Routes, Head} from 'react-static'
import { MuiThemeProvider} from '@material-ui/core/styles';
import { theme } from './theme';
import './app.css'

class App extends Component {
  render() {
    return (
      <Root>
        <Head>
          <meta name="facebook-domain-verification" content="wmhiqo5j9uhnmag1j2gi3w44mod0qe" />
        </Head>
        <MuiThemeProvider theme={theme}>
          <Routes />
        </MuiThemeProvider>
      </Root>
    )
  }
}

export default App
